var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0078 3.00391C30.8358 3.00391 31.5078 3.67591 31.5078 4.50391V31.5039C31.5078 32.3319 30.8358 33.0039 30.0078 33.0039H9.00781C8.17981 33.0039 7.50781 32.3319 7.50781 31.5039V28.5039H4.50781V25.5039H7.50781V22.5039H4.50781V19.5039H7.50781V16.5039H4.50781V13.5039H7.50781V10.5039H4.50781V7.50391H7.50781V4.50391C7.50781 3.67591 8.17981 3.00391 9.00781 3.00391H30.0078ZM28.5078 6.00391H10.5078V30.0039H28.5078V6.00391ZM21.0078 12.0039V16.5039H25.5078V19.5039H21.0063L21.0078 24.0039H18.0078L18.0063 19.5039H13.5078V16.5039H18.0078V12.0039H21.0078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoBanner);
export default __webpack_public_path__ + "static/media/iconoBanner.db6e2322fd2e11998e83a1356b445c75.svg";
export { ForwardRef as ReactComponent };